import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/activity-types/ActivityTypesAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { ActivityTypeEditForm } from "./ActivityTypeEditForm";

export function ActivityTypeEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, activityType } = useSelector(
    (state) => ({
      actionsLoading: state.activityTypes.actionsLoading,
      isSuccess: state.activityTypes.isSuccess,
      type: state.activityTypes.type,
      activityType: state.activityTypes.activityType
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getActivityType(id));
    return () => dispatch(actions.cleanActivityTypesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Faaliyet Türü";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  /** Belli Bir Faaliyet Türünü Kaydeder */
  const saveActivityType = (values) => {
    dispatch(actions.saveActivityType(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/faaliyet-turleri`), 2500);
  };

  const btnRef = useRef();  
  const saveActivityTypeClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <ActivityTypeEditForm 
            activityType={activityType}
            btnRef={btnRef} 
            saveActivityType={saveActivityType}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveActivityTypeClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}